import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  header: {
    defaultMessage: 'Add Address to Blacklist',
    description: 'Header for add blacklist entry modal',
    id: 'GuOmkH',
  },
  description: {
    defaultMessage: 'Orders shipping to this address will be automatically tagged for review.',
    description: 'Description text for add blacklist entry modal',
    id: 'LeE6mq',
  },
  addressLine1Label: {
    defaultMessage: 'Address Line 1',
    description: 'Label for address line 1 input',
    id: 'VHjC3j',
  },
  addressLine1Placeholder: {
    defaultMessage: 'Street address',
    description: 'Placeholder for address line 1 input',
    id: 'TFKEXp',
  },
  addressLine2Label: {
    defaultMessage: 'Address Line 2',
    description: 'Label for address line 2 input',
    id: '9Bei5z',
  },
  addressLine2Placeholder: {
    defaultMessage: 'Apartment, suite, etc. (optional)',
    description: 'Placeholder for address line 2 input',
    id: 'xYuIs4',
  },
  cityLabel: {
    defaultMessage: 'City',
    description: 'Label for city input',
    id: 'Xw/VVZ',
  },
  stateLabel: {
    defaultMessage: 'State / Province',
    description: 'Label for state input',
    id: 'Mkj5WD',
  },
  postalCodeLabel: {
    defaultMessage: 'Postal Code',
    description: 'Label for postal code input',
    id: 'wfW8Ax',
  },
  countryLabel: {
    defaultMessage: 'Country',
    description: 'Label for country dropdown',
    id: 'WX3NeV',
  },
  countryPlaceholder: {
    defaultMessage: 'Select country',
    description: 'Placeholder for country dropdown',
    id: 'SRo2jk',
  },
  reasonLabel: {
    defaultMessage: 'Reason',
    description: 'Label for reason input',
    id: '75aLrv',
  },
  reasonPlaceholder: {
    defaultMessage: 'Why is this address being blacklisted? (optional)',
    description: 'Placeholder for reason input',
    id: 'PwutVu',
  },
  reasonMaxLengthError: {
    defaultMessage: 'Reason cannot exceed 500 characters.',
    description: 'Error message when reason exceeds maximum length',
    id: 'gQRdZ9',
  },
  cancel: {
    defaultMessage: 'Cancel',
    description: 'Cancel button text',
    id: 'hHNj31',
  },
  add: {
    defaultMessage: 'Add to Blacklist',
    description: 'Add button text',
    id: 'utYfMs',
  },
  adding: {
    defaultMessage: 'Adding...',
    description: 'Button text while add is in progress',
    id: '5QZAWm',
  },
  requiredFieldError: {
    defaultMessage: 'This field is required',
    description: 'Error message for required field validation',
    id: 'ZBgUlO',
  },
});
